import React, { ReactNode, useEffect, useState } from "react";
import { RiMenu2Fill } from "react-icons/ri";
import SideBar from "./sidebar";
import TopBar from "./topbar";
import Snackbar from "../others/snackbar";
import SnackbarComponent from "../others/snackbar";
import ToastComponent from "../others/ToastComponent";


const Layout = ({ children }) => {
  const [toggled, setToggled] = React.useState(false);
  const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(window.matchMedia(query).matches);

    useEffect(() => {
      const media = window.matchMedia(query);
      const listener = () => setMatches(media.matches);
      media.addEventListener("change", listener);
      return () => media.removeEventListener("change", listener);
    }, [query]);

    return matches;
  };

  const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    setToggled(false); // Collapse sidebar on mobile by default
  }, [isMobile]);

  const handleClickedOutside = () => {
    setToggled(false);
  };

  return (
    <div className="w-full">
      <TopBar />
      <div className="w-full flex p-0 m-0">
        <div>
          {toggled && isMobile && (
            <div className="pl-5">
              <SideBar
                toggled={toggled}
                handleClickedOutside={handleClickedOutside}
              />
            </div>
          )}

          {!isMobile && (
            <div className="pl-0">
              <SideBar
                toggled={true}
                handleClickedOutside={handleClickedOutside}
              />
            </div>
          )}
        </div>

        <div className="flex-1 bg-light-color dark:bg-light-color-dark relative w-full px-1 lg:px-2 ">
          <div
            onClick={() => setToggled(!toggled)}
            className=" w-10 flex md:hidden items-center justify-center py-1 shadow-md absolute top-2 left-5"
          >
            <RiMenu2Fill size={25} />
          </div>
          <div>
            {/* <SnackbarComponent open={true} /> */}
          </div>
          <div className="my-12 lg:my-3 ">
            <ToastComponent />
            {children}</div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
